import { Col, Divider, Row, Tooltip } from "antd";
import PageHeaderAllPage from "../../../Components/layouts/PageHeaderAllPage";
import Preloader from "../../../Components/Preloader";
import Navbar from "../../Menu/Navbar";
import Footer from "../Sections/Footer";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import { useCookies } from "react-cookie";
import {
  toGetMyLoyaltyHistory,
  toGetMyWalletHistory,
  toGetProfil,
} from "../../../apis/actions/auth.actions";
import { useEffect, useState } from "react";
import AccountDetails from "./AccountDetails";
import MyCars from "./MyCars";
import MyOrders from "./MyOrders";
import { toGetMyVehicle } from "../../../apis/actions/vehicle.actions";
import { useLocation, useNavigate } from "react-router-dom";
import {
  RiWallet3Line,
  RiCoinFill,
  RiCoinsLine,
  RiExchangeLine,
  RiGift2Fill,
  RiBillLine,
  RiCarLine,
  RiLogoutBoxRLine,
  RiStackLine,
  RiUserLine,
  RiVipCrownFill,
} from "react-icons/ri";
import { LiaUserEditSolid } from "react-icons/lia";
import LoyaltyExchange from "./LoyaltyExchange";
import MyInvoices from "./MyInvoices";
import { useTranslation } from "react-i18next";
import { resetState } from "../../../apis/slices/globalSlice";
import { confirmAction } from "../../../utils/Utils";
import { toSyncMyCartNow } from "../../../apis/actions/cart.actions";
import MyTransactionsHistory from "./MyTransactionsHistory";
import EditAccountDetails from "./EditAccountDetails";
import carsAdd from "../../../assets/add-vehicles.svg";
import GiftModal from "./GiftModal";
import MembershipAvatar, {
  MembershipBadgeType,
} from "../../../Components/profile/MembershipAvatar";
const Profil = () => {
  const { profil } = useSelector((state: RootState) => state?.login);
  const membershipCode = String(profil?.data?.membership?.code || "normal")
    .trim()
    .toLowerCase();
  const membershipLevel: MembershipBadgeType =
    membershipCode === "silver"
      ? "silver"
      : membershipCode === "gold" || membershipCode === "golden"
        ? "golden"
        : membershipCode === "platinum" || membershipCode === "platinium"
          ? "platinium"
          : "normal";
  const membershipName = String(profil?.data?.membership?.name || "").trim();
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const items = [
    {
      id: 1,
      label: t("profile.details"),
      icon: <RiUserLine aria-hidden />,
      component: <AccountDetails />,
      extra: (
        <Tooltip
          title={t("profile.edit")}
          overlayClassName="ac--share-tooltip"
          placement="bottom"
        >
          <span
            className="ac-profile-tooltip-trigger"
            role="button"
            tabIndex={0}
            onClick={() => handleOpenModalProfile(profil.data)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleOpenModalProfile(profil.data);
              }
            }}
          >
            <LiaUserEditSolid aria-hidden />
          </span>
        </Tooltip>
      ),
    },
    {
      id: 2,
      label: t("profile.orders"),
      icon: <RiStackLine aria-hidden />,
      component: <MyOrders />,
    },
    {
      id: 3,
      label: t("profile.invoices"),
      icon: <RiBillLine aria-hidden />,
      component: <MyInvoices />,
    },
    {
      id: 4,
      label: t("profile.cars"),
      icon: <RiCarLine aria-hidden />,
      component: <MyCars />,
      extra: (
        <Tooltip
          title={t("profile.car.addCar")}
          overlayClassName="ac--share-tooltip"
          placement="bottom"
        >
          <span
            className="ac-profile-tooltip-trigger ac-profile-tooltip-trigger--img"
            role="button"
            tabIndex={0}
            onClick={() => navigate("/add-car")}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                navigate("/add-car");
              }
            }}
          >
            <img src={carsAdd} alt="" width={50} />
          </span>
        </Tooltip>
      ),
    },
    {
      id: 6,
      label: t("profile.transaction.title1"),
      icon: <RiCoinsLine aria-hidden />,
      component: <MyTransactionsHistory type="loyalty" />,
    },
    {
      id: 7,
      label: t("profile.transaction.title2"),
      icon: <RiWallet3Line aria-hidden />,
      component: <MyTransactionsHistory type="wallet" />,
    },
    {
      id: 5,
      label: t("profile.logout"),
      icon: <RiLogoutBoxRLine aria-hidden />,
    },
  ];
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [cookies, , removeCookie] = useCookies(["apiKey"]);
  const [selected, setSelected] = useState<any>(items[0]);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showGiftModal, setShowGiftModal] = useState<boolean>(false);

  const [selectedData, setSelectedData] = useState<any>(null);
  const [showModalEditProfile, setShowModalEditProfile] =
    useState<boolean>(false);

  const handleOpenModal = (data: any) => {
    setSelectedData(data);
    setShowModal(true);
  };

  const handleOpenModalProfile = (data: any) => {
    setShowModalEditProfile(true);
  };

  useEffect(() => {
    if (cookies.apiKey) {
      dispatch(toGetProfil(i18n.language));
      dispatch(toGetMyVehicle(i18n.language));
      dispatch(toGetMyLoyaltyHistory());
      dispatch(toGetMyWalletHistory());

      if (location.state?.activeTab) {
        const tabToSelect = items.find(
          (item) => item.id === location.state.activeTab
        );
        if (tabToSelect) {
          setSelected(tabToSelect);
        }
      }
    }
  }, [dispatch, location.state]);
  const toSelectItem = async (item: any) => {
    if (item.id !== 5) {
      setSelected(item);
      return;
    }

    const confirmed = await confirmAction({
      title: t("profile.logoutConfirm.title"),
      text: t("profile.logoutConfirm.text"),
      confirmText: t("profile.logoutConfirm.confirm"),
      cancelText: t("profile.logoutConfirm.cancel"),
    });
    if (!confirmed) return;

    await dispatch(toSyncMyCartNow());
    removeCookie("apiKey", { path: "/" });
    dispatch(resetState());
    dispatch(toGetProfil(i18n.language));
    navigate("/");
    dispatch(resetState());
  };

  return (
    <>
      <Navbar type="internal" />
      <Preloader loading={profil?.status === "idle"} />
      <main className="main">
        <PageHeaderAllPage
          tone="brand"
          current={t("profile.profil")}
          banner="assets/imgs/page-header/profil.jpg"
          link="profil"
          showMenu={true}
          type="profil"
        >
          <div className="ac--modern-wallet-banner">
            <div className={`ac--wallet-card ac--wallet-card--${membershipLevel}`}>
              <div className="ac--wallet-balance-section">
                <div className="ac--wallet-balance-row">
                  <div className="ac--balance-item">
                    <RiWallet3Line className="ac--balance-icon" aria-hidden />
                    <h2 className="ac--wallet-balance icon-saudi_riyal icon-saudi_riyal">
                      {profil?.data?.wallet_balance != null
                        ? Number(profil.data.wallet_balance).toFixed(2)
                        : "—"}
                    </h2>
                    <p className="ac--wallet-subtitle">{t("profile.balance")}</p>
                  </div>
                  <Divider
                    type="vertical"
                    className="ac--divider-walllet ac--divider-walllet--row"
                  />
                  <div className="ac--balance-item">
                    <RiCoinFill className="ac--balance-icon points" aria-hidden />
                    <h2 className="ac--wallet-points">
                      {profil?.data?.loyalty_balance != null
                        ? Number(profil.data.loyalty_balance).toFixed(0)
                        : "—"}
                    </h2>
                    <p className="ac--wallet-subtitle">{t("payment.points")}</p>
                  </div>
                </div>
                {/* <Row justify="end" style={{marginTop:"1rem"}}>
                  <Col span={10} className="ac--balance-item">
                    <p className="ac--wallet-subtitle" style={{fontSize:"15px", color:"#999"}}>
                      {t("profile.expiration")}{" : "} {profil?.data.expiration_date_loyalty}
                    </p>
                  </Col>
                </Row>
                */}
              </div>

              <div className="ac--wallet-actions">
                <div className="ac--wallet-actions__inner">
                  <button
                    type="button"
                    className="ac--action-item"
                    onClick={() =>
                      handleOpenModal(profil?.data?.loyalty_balance)
                    }
                  >
                    <RiExchangeLine
                      className="ac--action-icon transactions"
                      aria-hidden
                    />
                    <span className="ac--wallet-subtitle ac--wallet-text-size">
                      {t("profile.exchange")}
                    </span>
                  </button>
                  <button
                    type="button"
                    className="ac--action-item"
                    onClick={() => setShowGiftModal(true)}
                  >
                    <RiGift2Fill
                      className="ac--action-icon transactions"
                      aria-hidden
                    />
                    <span className="ac--wallet-subtitle ac--wallet-text-size">
                      {t("profile.gift")}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </PageHeaderAllPage>

        {profil?.data && (
          <section className="ac-profile-page">
            <div className="container ac-profile-page__container">
              <Row
              gutter={[
                { xs: 16, sm: 20, md: 24, lg: 28, xl: 28, xxl: 28 },
                { xs: 20, sm: 24, md: 28, lg: 32, xl: 32, xxl: 32 },
              ]}
              className="ac-profile-page__row"
            >
                <Col xs={24} sm={24} md={24} lg={8} xl={7} xxl={6}>
                  <aside className="ac-profile-sidebar">
                    <div className="ac-profile-sidebar__user">
                      <MembershipAvatar
                        src={
                          typeof profil?.data?.image_1920 === "string"
                            ? profil.data.image_1920
                            : null
                        }
                        badgeType={membershipLevel}
                        alt=""
                      />
                      <p className="ac-profile-sidebar__welcome ac--font-expo">
                        {t("profile.welcome")}{" "}
                        {profil?.data?.title && `${profil?.data?.title} `}
                        {profil?.data?.name}
                      </p>
                      {membershipName ? (
                        <div
                          className={`ac-profile-membership ac-profile-membership--${membershipLevel}`}
                          aria-label={`${t("profile.membership")}: ${membershipName}`}
                        >
                          <span className="ac-profile-membership__seal" aria-hidden>
                            <RiVipCrownFill />
                          </span>
                          <span className="ac-profile-membership__copy">
                            <span className="ac-profile-membership__eyebrow">
                              {t("profile.membership")}
                            </span>
                            <strong className="ac-profile-membership__name">
                              {membershipName}
                            </strong>
                          </span>
                          <span className="ac-profile-membership__shine" aria-hidden />
                        </div>
                      ) : null}
                    </div>

                    <nav
                      className="ac-profile-nav"
                      aria-label={t("profile.profil")}
                    >
                      {items.map((el) => (
                        <button
                          key={el.id}
                          type="button"
                          className={`ac-profile-nav__item${
                            selected.id === el.id
                              ? " ac-profile-nav__item--active"
                              : ""
                          }`}
                          onClick={() => toSelectItem(el)}
                        >
                          <span className="ac-profile-nav__icon-wrap">
                            {el.icon}
                          </span>
                          <span className="ac-profile-nav__label">
                            {el.label}
                          </span>
                        </button>
                      ))}
                    </nav>
                  </aside>
                </Col>
                <Col xs={24} sm={24} md={24} lg={16} xl={17} xxl={18}>
                  <div className="ac-profile-content">
                    <header className="ac-profile-content__head">
                      <h2 className="ac-profile-content__title ac--font-expo">
                        {selected?.label}
                        <span
                          className={`ac-profile-content__actions ac--icons-profile ${
                            i18n.language === "ar" ? "me-2" : "ms-2"
                          }`}
                        >
                          {selected?.extra}
                        </span>
                      </h2>
                    </header>
                    <div className="ac-profile-content__body">
                      {selected?.component}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </section>
        )}
        <Footer />
      </main>

      <LoyaltyExchange
        showModal={showModal}
        setShowModal={setShowModal}
        selectedData={selectedData}
      />

      <EditAccountDetails
        showModal={showModalEditProfile}
        setShowModal={setShowModalEditProfile}
        selectedData={profil?.data}
      />
      <GiftModal open={showGiftModal} onClose={() => setShowGiftModal(false)} />
    </>
  );
};
export default Profil;
